import LabTable from './lab-table';

export default LabTable;
